import store from '@utils/store/cookie';
import { getUserInfo } from '@api/user';

const LOGIN_KEY = 'login_status';

const state = {
    footer: true,
    isLoading: false,
    token: store.get(LOGIN_KEY) || null,
    backgroundColor: '',
    userInfo: null,
    header: true,
    headerTitle: '首页'
};

const mutations = {
    SHOW_FOOTER(state) {
        state.footer = true;
    },
    HIDE_FOOTER(state) {
        state.footer = false;
    },
    SHOW_LOADING(state) {
        state.isLoading = true;
    },
    HIDE_LOADING(state) {
        state.isLoading = false;
    },
    LOGIN(state, token, expires_time) {
        state.token = token;
        store.set(LOGIN_KEY, token, expires_time);
    },
    LOGOUT(state) {
        state.token = undefined;
        store.remove(LOGIN_KEY);
    },
    BACKGROUND_COLOR(state, color) {
        state.color = color;
        document.body.style = 'background:' + color;
    },
    UPDATE_USERINFO(state, userInfo) {
        state.userInfo = userInfo;
    },
    HEADER_RIGHT(state, right) {
        state.headerRight = right;
    },
    SHOW_HEADER(state) {
        state.header = true;
    },
    HIDE_HEADER(state) {
        state.header = false;
    },
    HEADER_TITLE(state, title) {
        state.headerTitle = title;
    }
};
const actions = {
    USERINFO({ state, commit }, force) {
        console.log('store USERINFO', force, state.userInfo);
        if (state.userInfo !== null && !force) return Promise.resolve(state.userInfo);
        else
            return new Promise((reslove, reject) => {
                getUserInfo()
                    .then(res => {
                        commit('UPDATE_USERINFO', res.data);
                        reslove(res.data);
                    })
                    .catch(() => {
                        reject({ msg: '网络连接失败!请检查您的网络', code: 1 });
                    });
            }).catch(() => {});
    }
};

export default {
    state,
    mutations,
    actions
};
